import Vue from "@/main";

var graphicDotsine = null;
var graphicDotsineLine = null;
var selectPoint = null;
var dataPoint = null;
var lineEl = null;
var crossSectionPoint = null;
var crossSection = null;
var earthworkPoint = null;
var graphicLayer = null;

// 添加绘制图层
const createLayer = () => {
  if (!graphicDotsine) {
    graphicDotsine = new mars3d.layer.GraphicLayer();
    Vue.$GLOBAL.map.addLayer(graphicDotsine);
  }
};

const clearLayer = () => {
  if (graphicDotsine) {
    graphicDotsine.clear();
    graphicDotsine.stopDraw();
    if (graphicDotsineLine) graphicDotsineLine.clear();
    Vue.$GLOBAL.map.removeLayer(graphicDotsine);
  }
  if (graphicLayer) {
    graphicLayer.clear();
    Vue.$GLOBAL.map.removeLayer(graphicLayer);
  }
  lineEl = null;
  selectPoint = null;
  dataPoint = null;
  graphicDotsine = null;
  crossSectionPoint = null;
  crossSection = null;
  graphicLayer = null;
};

const createGraphic = () => {
  graphicDotsine
    .startDraw({
      type: "point",
      style: {
        label: {
          text: "",
          pixelOffsetY: -50,
          visibleDepth: false,
          font_size: 14,
        },

        pixelSize: 20,
        color: Vue.$GLOBAL.default_markIconColor,
        scaleByDistance_farValue: 0.8,
        scaleByDistance_far: 1000,
        scaleByDistance_near: 100,
        scaleByDistance: true,
        visibleDepth: false,
        horizontalOrigin: Cesium.HorizontalOrigin.CENTER, //可帮助定位图标相对焦点小方格的位置。
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM, //可帮助定位图标相对焦点小方格的位置。
      },
    })
    .then((res) => {
      selectPoint = res;
    });
  graphicDotsine.off();
};

const createStakeGraphic = (stake, slope, elevation, position, buildTender) => {
  if (!graphicDotsine) {
    graphicDotsine = new mars3d.layer.GraphicLayer();
    Vue.$GLOBAL.map.addLayer(graphicDotsine);
  }
  if (dataPoint) {
    graphicDotsine.removeGraphic(dataPoint);
    dataPoint = null;
  }

  const graphic = new mars3d.graphic.PointEntity({
    position,
    style: {
      label: {
        text: `\n对应桩号: ${stake}\n设计高程: ${elevation}米\n纵坡坡率: ${slope}`,
        pixelOffsetY: -120,
        visibleDepth: false,
        font_size: 14,
        outline: true,
        outlineColor: "#000",
        outlineWidth: 4,
      },

      pixelSize: 20,
      color: "#4ac2ff",
      scaleByDistance_farValue: 0.8,
      scaleByDistance_far: 1000,
      scaleByDistance_near: 100,
      scaleByDistance: true,
      visibleDepth: false,
      horizontalOrigin: Cesium.HorizontalOrigin.CENTER, //可帮助定位图标相对焦点小方格的位置。
      verticalOrigin: Cesium.VerticalOrigin.BOTTOM, //可帮助定位图标相对焦点小方格的位置。
    },
  });
  graphicDotsine.addGraphic(graphic);
  dataPoint = graphic;
  graphicDotsine.off();
};

const createLineEl = (positions) => {
  if (lineEl) {
    graphicDotsine.removeGraphic(lineEl);
    lineEl = null;
  }
  const graphic = new mars3d.graphic.PolylineEntity({
    positions,
    style: {
      width: 5,
      color: "#3388ff",
      clampToGround: true,
      visibleDepth: false,
    },
  });
  graphicDotsine.addGraphic(graphic);
  graphicDotsine.flyTo();
  lineEl = graphic;
  graphicDotsine.off();
};

const createCrossSectionPoint = () => {
  graphicDotsine
    .startDraw({
      type: "point",
      style: {
        label: {
          text: "",
          pixelOffsetY: -50,
          visibleDepth: false,
          font_size: 14,
          outline: true,
          outlineColor: "#000",
          outlineWidth: 4,
        },
        pixelSize: 20,
        color: Vue.$GLOBAL.default_markIconColor,
        scaleByDistance_farValue: 0.8,
        scaleByDistance_far: 1000,
        scaleByDistance_near: 100,
        scaleByDistance: true,
        visibleDepth: false,
        horizontalOrigin: Cesium.HorizontalOrigin.CENTER, //可帮助定位图标相对焦点小方格的位置。
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM, //可帮助定位图标相对焦点小方格的位置。
      },
    })
    .then((res) => {
      crossSectionPoint = res;
    });
  graphicDotsine.off();
};

const createCrossSection = (positions, text) => {
  graphicDotsine.clear();
  if (graphicDotsineLine) graphicDotsineLine.clear();
  crossSection = null;
  const graphic = new mars3d.graphic.PolylineEntity({
    positions,
    style: {
      label: {
        text,
        visibleDepth: false,
      },
      outline: true,
      outlineColor: "#fff",
      outlineWidth: 5,
      width: 50,
      color: "#3388ff",
      clampToGround: true,
      visibleDepth: false,
    },
  });
  graphicDotsine.addGraphic(graphic);
  graphicDotsine.flyTo();
  crossSection = graphic;
  graphicDotsine.off();
};

// 绘制点
const createEarthworkPoint = (off = false) => {
  // this.createLayer();
  graphicDotsine
    .startDraw({
      type: "point",
      style: {
        label: {
          text: "",
          pixelOffsetY: -50,
          visibleDepth: false,
          font_size: 14,
          outline: true,
          outlineColor: "#000",
          outlineWidth: 4,
        },
        pixelSize: 20,
        color: Vue.$GLOBAL.default_markIconColor,
        scaleByDistance_farValue: 0.8,
        scaleByDistance_far: 1000,
        scaleByDistance_near: 100,
        scaleByDistance: true,
        visibleDepth: false,
        horizontalOrigin: Cesium.HorizontalOrigin.CENTER, //可帮助定位图标相对焦点小方格的位置。
        verticalOrigin: Cesium.VerticalOrigin.BOTTOM, //可帮助定位图标相对焦点小方格的位置。
      },
    })
    .then((res) => {
      earthworkPoint = res;
    });
  if (off) graphicDotsine.off();
};

// 绘制点 + 线
// create Earthwork Line
const createEarthworkLine = (arr) => {
  if (!graphicDotsineLine) {
    graphicDotsineLine = new mars3d.layer.GraphicLayer();
    Vue.$GLOBAL.map.addLayer(graphicDotsineLine);
  }
  let position = arr.map((item) => {
    let [x, y, z] = item;
    return Cesium.Cartesian3.fromDegrees(x, y, z);
  });

  let earthworkLine = new mars3d.graphic.PolylineEntity({
    positions: position,
    style: {
      width: 5,
      color: "#ff0000",
      // 动画线材质
      show: true,
      depthFail: true,
      depthFailColor: "#ff0000",
    },
  });
  graphicDotsineLine.addGraphic(earthworkLine);
};

const drawDots = (arr, isFlyTo = true) => {
  console.log("drawDots", graphicLayer);
  // 判断路径图层是否存在

  // if (graphicDotsine !== null) {
  //   graphicDotsine.clear();
  // }
  if (!graphicLayer) {
    graphicLayer = new mars3d.layer.GraphicLayer();
    Vue.$GLOBAL.map.addLayer(graphicLayer);
  } else {
    // 清除路径图层内所有矢量数据
    graphicLayer.clear();
  }
  Vue.$NProgress.set(0.8).inc(0.2);
  let rPColor = Vue.$GLOBAL.default_markIconColor;
  let iurl = "/img/marker/mark" + rPColor.slice(1) + ".png";
  let scale = 1;
  let position, graphicDots, pixelOffsetY, font_size;
  arr.forEach((item) => {
    if (item.type == 1) {
      iurl = "/img/marker/pileNumber.png";
      scale = 2.2;
      rPColor = "#ff3535";
      pixelOffsetY = -60;
      font_size = 22;
    } else {
      rPColor = "#ff3535";
      iurl = "/img/marker/pileNumber2.png";
      scale = 2;
      pixelOffsetY = -30;
      font_size = 20;
    }
    position = item.position
      ? item.position
      : JSON.parse(item.bimVideoRoamingContent.contentValue);
    graphicDots = graphicLayer.addGraphic([
      {
        type: "billboard",
        position: new mars3d.LngLatPoint(position[0], position[1], position[2]),
        style: {
          image: iurl,
          scale: scale,
          scaleByDistance_farValue: 0.2,
          scaleByDistance_far: 100000,
          scaleByDistance_near: 100,
          scaleByDistance_nearValue: 0.5,
          scaleByDistance: true,
          label: {
            //不需要文字时，去掉label配置即可
            text: item.text.toString(),
            font_size: font_size,
            font_family: "黑体",
            color: rPColor,
            outlineColor: "#fff",
            outlineWidth: 4,
            outline: true,
            pixelOffsetY: pixelOffsetY,
            visibleDepth: false,
            distanceDisplayCondition: true,
            distanceDisplayCondition_far: 10000,
            distanceDisplayCondition_near: 0,
          },
          visibleDepth: false,
          horizontalOrigin: Cesium.HorizontalOrigin.CENTER, //可帮助定位图标相对焦点小方格的位置。
          verticalOrigin: Cesium.VerticalOrigin.BOTTOM, //可帮助定位图标相对焦点小方格的位置。
          //clampToGround: true, //贴地
        },
        // flyTo: true,
      },
    ]);
    // graphicDotsArr.push(graphicDots);
    item.uid = graphicDots[0].uuid;
  });
  // 完成线的绘制 飞行
  if (graphicLayer != undefined && isFlyTo) {
    if (graphicLayer) {
      graphicLayer.flyTo({
        complete: () => {
          Vue.$NProgress.done(true);
        },
      });
    }
  }
  Vue.$NProgress.done(true);
};

export {
  graphicDotsine,
  graphicDotsineLine,
  selectPoint,
  dataPoint,
  createLayer,
  clearLayer,
  createGraphic,
  createStakeGraphic,
  createLineEl,
  createCrossSectionPoint,
  createCrossSection,
  createEarthworkPoint,
  createEarthworkLine,
  drawDots,
};
